import React, { useState } from "react";
import Slider from "./Slider";
import List from "./List";
import Button from "./Button";
import Select from "react-select";

const Footer = () => {
  const [humbugerclass, sethumbergerClass] = useState("humbergerdiv");
  const [reponisveMenu, setResponsiveMenu] = useState(false);

  const burgerAnimation = () => {
    if (humbugerclass == "humbergerdiv") {
      sethumbergerClass("cross");
      setResponsiveMenu(true);
    } else {
      sethumbergerClass("humbergerdiv");
      setResponsiveMenu(false);
    }
  };

  const pages = [
    {
      name: "About",
      url: "/about",
    },
    {
      name: "Careers",
      url: "/careers",
    },
    {
      name: "Terms & Privacy Policy",
      url: "/privacypolicy",
    },
    {
      name: "Contact us",

      url: "/contactus",
    },
  ];

  const options = [
    { value: "karachi", label: "Karachi" },
    { value: "lahore", label: "Lahore" },
    { value: "islamabad", label: "Islamabad" },
    { value: "rawalpindi", label: "Rawalpindi" },
    { value: "faisalabad", label: "Faisalabad" },
    { value: "multan", label: "Multan" },
    { value: "peshawar", label: "Peshawar" },
    { value: "quetta", label: "Quetta" },
    { value: "sialkot", label: "Sialkot" },
    { value: "gujranwala", label: "Gujranwala" },
  ];
  return (
    <div className="z-40 bg-black py-2 border-b border-[#a19f9f]  o">
      <div
        className="flex flex-col lg:flex-row gap-4 relative w-full justify-between
items-center lg:justify-between lg:items-center px-4 pb-4 pt-8  md:py-4 max-w-[1480px] mx-auto  z-20  "
      >
        <div className="px-2 ">
          <img
            src={"/assets/logos/rebhub_White2.png"}
            alt="rebhub"
            className="w-[100px]"
          />
        </div>

        <div className="">
          <List listItem={pages} bgColor="black" />
        </div>
        <div className="z-50">
          <ul className="wrapper flex  ">
            <a
              href="https://m.facebook.com/rebhub.pk
"
              target="_blank"
            >
              <li className="icon facebook ">
                <span className="tooltip " translate="">
                  Facebook
                </span>
                <span>
                  <i className="fab fa-facebook-f "></i>
                </span>
              </li>
            </a>
            {/* <a
              href="https://m.facebook.com/rebhub.pk
"
              target="_blank"
            >
              <li className="icon twitter">
                <span className="tooltip">Twitter</span>
                <span>
                  <i className="fab fa-twitter"></i>
                </span>
              </li>
            </a> */}
            <a
              href="https://www.instagram.com/rebhub.pk/
"
              target="_blank"
            >
              <li className="icon instagram">
                <span className="tooltip">Instagram</span>
                <span>
                  <i className="fab fa-instagram"></i>
                </span>
              </li>
            </a>

            <a
              href="https://www.youtube.com/@REBhub
"
              target="_blank"
            >
              <li className="icon youtube">
                <span className="tooltip">Youtube</span>
                <span>
                  <i className="fab fa-youtube"></i>
                </span>
              </li>
            </a>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
